import { render, staticRenderFns } from "./Words.vue?vue&type=template&id=f651f522&scoped=true"
import script from "./Words.vue?vue&type=script&lang=js"
export * from "./Words.vue?vue&type=script&lang=js"
import style0 from "./Words.vue?vue&type=style&index=0&id=f651f522&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f651f522",
  null
  
)

export default component.exports